import "core-js/modules/es.number.constructor.js";
var __default__ = {
  name: "MonthlyStudentTable",
  props: {
    student: {
      type: Object,
      default: function _default() {}
    },
    index: {
      type: Number,
      default: 0
    },
    days: {
      type: Number,
      default: 30
    },
    monthData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    displayLabel: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    handleCommentEdit: function handleCommentEdit(student) {
      this.$emit("handleCommentEdit", student);
    }
  }
};
import { useAbsentAlertStore } from "@/stores/absentAlert";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    var absentAlertStore = useAbsentAlertStore();
    return {
      __sfc: true,
      absentAlertStore: absentAlertStore
    };
  }
});